module.exports = __webpack_public_path__ + "static/media/cerrar_sesion.cdf9e20a.svg";